import React from 'react';
import useTranslate from '../../../../../customHooks/useTranslate';
import LoadedOptionsTypeahead from '../../../../../muiComponents/LoadedOptionsTypeahead';
import { IHotelListItem } from '../../../contexts/HotelsListContext';
import {
    generatePath,
    matchPath,
    useHistory,
    useLocation,
} from 'react-router-dom';
import {
    zitoneoRouteDefinitions,
    zitoneoRoutes,
} from '../../../utils/zitoneoRoutes';
import encodeBase64, { decodeBase64 } from '../../../../../utils/encodeBase64';
import Tooltip from '../../../../../muiComponents/Tooltip';
import { readOnlyEntities } from '../../../../../utils/commonVariables/entityKeys';
import { useODataMultipleQueries } from '../../../../../customHooks/useODataMultipleQueries';

const HotelSelector = ({
    isInHotelPresentation,
}: {
    isInHotelPresentation: boolean;
}) => {
    const translate = useTranslate();
    const history = useHistory();
    const location = useLocation();
    const { pathname } = useLocation();
    const match = matchPath<{ idEncoded: string; 0?: string }>(pathname, {
        path: [
            `${zitoneoRouteDefinitions.HOTEL_PRESENTATION}/*`,
            zitoneoRouteDefinitions.HOTEL_PRESENTATION,
        ],
    });
    const idEncoded = match?.params?.idEncoded;
    const selectedHotelId = idEncoded ? parseInt(decodeBase64(idEncoded)) : 0;

    const queries = [
        {
            key: 'supplierHotels',
            endpoint: {
                entityName: readOnlyEntities.SupplierHotel,
                select: ['Id', 'Name'],
                filter: [`Hotel/ZitoneoMembership eq true`],
                orderBy: 'Name asc',
            },
        },
    ];

    const { supplierHotels } = useODataMultipleQueries({
        queries,
        dependencies: [],
    });

    const handleHotelChange = (
        _event: React.SyntheticEvent,
        selectedHotel: IHotelListItem | null
    ) => {
        if (selectedHotel?.Id && match) {
            history.push({
                ...location,
                pathname: generatePath(match.path, {
                    ...match.params,
                    idEncoded: encodeBase64(selectedHotel.Id),
                }),
            });
        }
    };

    const handleGoToHotelPresentation = (selectedId: number) => {
        history.push(zitoneoRoutes.HOTEL_PRESENTATION(selectedId.toString()));
    };

    return (
        <>
            {idEncoded ? (
                <div className='zitoneo-header__hotel-selector__container'>
                    <Tooltip
                        titleText={'back_to_hotel_summary'}
                        hideTooltip={isInHotelPresentation}
                    >
                        <label
                            className={`zitoneo-header__hotel-selector__label ${
                                !isInHotelPresentation ? '--link' : ''
                            }`}
                            onClick={() =>
                                !isInHotelPresentation &&
                                handleGoToHotelPresentation(selectedHotelId)
                            }
                        >
                            {translate('property')}
                        </label>
                    </Tooltip>
                    <LoadedOptionsTypeahead
                        className='zitoneo-header__hotel-typeahead'
                        options={supplierHotels.data}
                        optionsLabelKey='Name'
                        idValue={selectedHotelId}
                        handleChange={handleHotelChange}
                        disabled={supplierHotels.isLoading}
                        // disableClearable
                        required
                    />
                </div>
            ) : (
                ''
            )}
        </>
    );
};

export default HotelSelector;
